"use client";
import React, { useEffect } from "react";
import ReactModal from "react-modal";
import HeroSectionForm from "../home/HeroSection/HeroSectionForm";
import Image from "next/image";

function Modal({ isModalOpen, setIsModalOpen }) {
  useEffect(() => {
    const rootElement = document.getElementById("__next");
    if (rootElement) {
      ReactModal.setAppElement(rootElement);
    }
  }, []);

  return (
    <ReactModal
      isOpen={isModalOpen}
      onRequestClose={() => setIsModalOpen(false)}
      ariaHideApp={false}
      className="flex items-center justify-center m-3"
      overlayClassName="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
    >
      <div className="bg-gray-50 relative z-0 rounded-lg flex flex-col md:flex-row w-[70%] items-center justify-center">
        {/* Close Button */}
        <button
          className="absolute top-4 right-4 text-gray-600 hover:text-black"
          onClick={() => setIsModalOpen(false)}
        >
          ✕
        </button>

        {/* Left Section: Instructions */}
        <div
          id="Courses"
          className="bg-gray-50 py-24 max-md:hidden relative z-10 "
          style={{
            backgroundImage: `url('/modalimage.svg')`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            width: "100%",
            height: "auto",
          }}
        >
          <div className="max-sm:hidden w-full flex flex-col justify-center items-left p-8 lg:pl-20 rounded-lg">
            <Image src="/amico.svg" width={1300} height={1300} />
          </div>

          
          {/* <div className="absolute top-0 bottom-0 left-[105%] w-px border-r-2 border-dashed border-teal-500 z-60"></div> */}
        </div>

        {/* Right Section: Form */}
        <div className="bg-gray-50 p-8 max-sm:w-full rounded-lg">
          <HeroSectionForm setIsModalOpen={setIsModalOpen} />
        </div>
      </div>
    </ReactModal>
  );
}

export default Modal;
